import React, { useState, useEffect } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
// import { isMobile } from 'react-device-detect';

/**Ant-design */
import { Card, List, Select, Col, Form, Row } from "antd";

/**Redux-Ducks */
import {
  obtenerSistemaINE,
  obtenerSistemaOPLE,
} from "../../../redux/consultavacantes/sistemasDucks";

import {
  getObjetivos,
  cleanObjetivos,
  getFunciones,
  cleanFunciones,
  getRequisitos,
  cleanRequisitos,
  getObjetivoINE,
  cleanObjetivosINE,
  getFuncionesINE,
  cleanFuncionesINE,
  getRequisitosINE,
  cleanRequisitosINE,
  PerfilesINE,
  PerfilesOPLE,
} from "../../../redux/consultavacantes/descripcionpuestoDucks";

import {
  obtenerEstadosPuesto,
  asignarIdestado,
  getNombreEstado,
} from "../../../redux/consultavacantes/cestadoDucks";

import {
  cleanVacanteOPLE,
  getVacantes,
  getVacantesOples,
  asignarVacante,
  asignarListaVacantes,
  limpiarDatos,
} from "../../../redux/consultavacantes/consultaVacantesDucks";

import {
  btnBandera,
  cleanbtnBandera,
  obtenerPostulacion,
  sistemBandera,
  getValidacionPostula,
} from "../../../redux/postulaciones/postulacionesDucks";

/**Estilos CSS */
import "../../../assets/css/Cvacantes.css";
import "./ConsultadeVacantes.css";

/* Modal */
import { ContenidoVacanteModalComponent } from "./ContenidoVacanteModal";

const { Option } = Select;

export const ConsultadeVacantesComponent = () => {
  /* empty text from list */
  let emptyData = {
    emptyText: "Seleccionar una opción para mostrar cargo/puesto",
  };

  const [showModalContenidoVacante, setShowModalContenidoVacante] =
    useState(false);
  const { autenticado, idAspirante } = useSelector(
    (state) => state.usuarioLogin
  );
  const { estadospuesto } = useSelector((state) => state.cestados);
  const {
    vacantesoples,
    vacantes,
    idSistema,
    idConcurso,
    idConvocatoria,
    listaVacantes,
    vacanteDetalle,
  } = useSelector((state) => state.consultaVacantes);
  const { listPostula } = useSelector((state) => state.postulacion);

  const dispatch = useDispatch();
  const store = useStore();

  const [estadosTodos, setEstadosTodos] = useState([]);
  const [vacantesTodos, setVacantesTodos] = useState([]);
  const [cargoPuestoActivo, setCargoPuestoActivo] = useState(true);
  const [cargoPuestoSeleccionado, setCargoPuestoSeleccionado] = useState(null);

  const validarDatos = () => {
    // // const ageExperienciaINE = store.getState().descripcionPuesto;
    // // const { requisitosINE } = ageExperienciaINE;

    // const ageExperienciaOPLE = store.getState().descripcionPuesto;
    // // const { requisitos } = ageExperienciaOPLE;

    let dataValidacion = {
      idAspirante: idAspirante,
      idFase: 1,
      idConcurso: idConcurso,
      idConvocatoria: idConvocatoria,
      aniosExpConv: 0,
      // idSistema === 1
      //   ? requisitosINE[0]?.tiempoExperiencia
      //   : requisitos[0]?.tiempoExperiencia,
    };
    dispatch(getValidacionPostula(dataValidacion));
    // console.log(dataValidacion);
  };

  const [estado, setEstado] = useState(null);
  const selectEstado = (idEstado) => {
    if (idEstado) {
      setEstado(idEstado);
      setCargoPuestoActivo(false);
      setVacante(undefined);
      dispatch(cleanObjetivos({}));
      dispatch(cleanFunciones({}));
      dispatch(cleanRequisitos({}));
      dispatch(PerfilesINE());
      dispatch(PerfilesOPLE());
      dispatch(limpiarDatos({}));
    } else {
      setEstado(undefined);
      setCargoPuestoActivo(true);
      setVacante(undefined);
      cleanVacanteOPLE({});
      dispatch(cleanObjetivos({}));
      dispatch(cleanFunciones({}));
      dispatch(cleanRequisitos({}));
      dispatch(limpiarDatos({}));
    }
  };

  /**
   * Función que controla la elección cargo/puesto
   *
   */
  const [vacante, setVacante] = useState(undefined);

  const selectVacante = (idCargoPuesto) => {
    if (idCargoPuesto === 999999) {
      dispatch(asignarListaVacantes(vacantesoples));
      dispatch(asignarVacante(vacantesoples[0]));
      dispatch(getObjetivos(vacantesoples[0]?.idCargoPuesto));
      dispatch(getFunciones(vacantesoples[0]?.idCargoPuesto));
      dispatch(getRequisitos(vacantesoples[0]?.idCargoPuesto));

      setVacante(idCargoPuesto);
    } else {
      if (idCargoPuesto) {
        let itemVacante = obtenerVacante(idCargoPuesto);
        dispatch(asignarListaVacantes([itemVacante]));
        dispatch(asignarVacante(itemVacante));

        setVacante(idCargoPuesto);
        dispatch(getObjetivos(idCargoPuesto));
        dispatch(getFunciones(idCargoPuesto));
        dispatch(getRequisitos(idCargoPuesto));
      } else {
        setVacante(undefined);
        dispatch(cleanObjetivos({}));
        dispatch(cleanFunciones({}));
        dispatch(cleanRequisitos({}));
        dispatch(limpiarDatos({}));
      }
    }
  };

  function obtenerVacante(idCargoPuesto) {
    if (vacantesoples !== undefined) {
      const resultado = vacantesoples.find(
        (item) => item.idCargoPuesto === idCargoPuesto
      );
      return resultado !== undefined ? resultado : null;
    } else {
      return null;
    }
  }

  const selectVacanteInit = (idTipoCargoPuesto) => {
    if (idSistema === 1) {
      setVacante(idTipoCargoPuesto);
    } else if (idSistema === 2) {
      selectEstado(1000);
      setVacante(idTipoCargoPuesto);
    }
  };

  const selectVacanteINE = (idTipoCargoPuesto) => {
    if (idTipoCargoPuesto === 999999) {
      dispatch(asignarListaVacantes(vacantes));
      /* Asigna por degault el primer resultado de cargo/vacantes */
      dispatch(asignarVacante(vacantes[0]));
      dispatch(getObjetivoINE(vacantes[0]?.idTipoCargoPuesto));
      dispatch(getFuncionesINE(vacantes[0]?.idTipoCargoPuesto));
      dispatch(getRequisitosINE(vacantes[0]?.idTipoCargoPuesto));
      setVacante(idTipoCargoPuesto);
    } else {
      if (idTipoCargoPuesto) {
        let itemVacante = obtenerVacanteINE(idTipoCargoPuesto);
        dispatch(asignarListaVacantes([itemVacante]));
        dispatch(asignarVacante(itemVacante));

        setVacante(idTipoCargoPuesto);
        dispatch(getObjetivoINE(idTipoCargoPuesto));
        dispatch(getFuncionesINE(idTipoCargoPuesto));
        dispatch(getRequisitosINE(idTipoCargoPuesto));
      } else {
        setVacante(undefined);
        dispatch(cleanObjetivosINE({}));
        dispatch(cleanFuncionesINE({}));
        dispatch(cleanRequisitosINE({}));
        dispatch(limpiarDatos({}));
      }
    }
  };

  function obtenerVacanteINE(idTipoCargoPuesto) {
    if (vacantes !== undefined) {
      const resultado = vacantes.find(
        (item) => item.idTipoCargoPuesto === idTipoCargoPuesto
      );
      return resultado !== undefined ? resultado : null;
    } else {
      return null;
    }
  }

  //Se limpia el state de Consulta Vacantes
  useEffect(() => {
    /* Se iniciializa los cargos puestos en todos */
    selectVacanteInit(999999);

    return () => {
      if (autenticado) {
        dispatch(cleanObjetivos({}));
        dispatch(cleanFunciones({}));
        dispatch(cleanRequisitos({}));
        dispatch(cleanObjetivosINE({}));
        dispatch(cleanFuncionesINE({}));
        dispatch(cleanRequisitosINE({}));
      } else {
        dispatch(limpiarDatos());
        dispatch(cleanObjetivos({}));
        dispatch(cleanFunciones({}));
        dispatch(cleanRequisitos({}));
        dispatch(cleanObjetivosINE({}));
        dispatch(cleanFuncionesINE({}));
        dispatch(cleanRequisitosINE({}));
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const cards = store.getState().consultaVacantes.vacanteDetalle;
    if (cards !== null) {
      validarDatos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vacanteDetalle]);

  useEffect(() => {
    let previdSistemaArray = [];
    const listRefres = store.getState().postulacion.listPostula;
    dispatch(cleanbtnBandera());
    // dispatch(limpiaSistemaBandera());
    if (listRefres !== null) {
      // const existePostulacion = listPostula.find(
      //   (e) => Number(e.idEstatusProceso) === 1
      // );
      dispatch(btnBandera(0));
      for (const row of listRefres) {
        if (Number(row.idEstatusProceso) === 1) {
          if (row.idCargoPuesto !== null) {
            if (!previdSistemaArray.includes(2)) {
              previdSistemaArray.push(2);
            }
          } else {
            if (!previdSistemaArray.includes(1)) {
              previdSistemaArray.push(1);
            }
          }

          dispatch(btnBandera(1));
        }
      }

      // if (existePostulacion !== undefined) {
      //   dispatch(btnBandera(1));
      // } else {
      //   dispatch(btnBandera(0));
      // }
    }
    dispatch(sistemBandera(previdSistemaArray));

    // eslint-disable-next-line
  }, [listPostula]);

  useEffect(() => {
    dispatch(obtenerEstadosPuesto(idConcurso, idConvocatoria));
    dispatch(asignarIdestado(estadospuesto?.idEstado));
    dispatch(getNombreEstado(estadospuesto?.nombreEstado));
    // eslint-disable-next-line
  }, [idConcurso, idConvocatoria]);

  useEffect(() => {
    dispatch(obtenerSistemaINE());
    dispatch(obtenerSistemaOPLE());
    dispatch(obtenerPostulacion());
  }, [dispatch]);

  useEffect(() => {
    if (estadospuesto !== undefined) {
      let estadosNew = [
        {
          idEstado: 1000,
          nombreEstado: "Todos",
        },
        ...estadospuesto,
      ];
      setEstadosTodos(estadosNew);
    }
  }, [estadospuesto]);

  useEffect(() => {
    if (idSistema === 2) {
      let vacantesNew = [
        {
          idCargoPuesto: 999999,
          denominacion: "Todos",
        },
        ...vacantesoples,
      ];
      setVacantesTodos(vacantesNew);
    }
    if (idSistema === 1) {
      let vacantesNew = [
        {
          idTipoCargoPuesto: 999999,
          nombretipo: "Todos",
        },
        ...vacantes,
      ];
      setVacantesTodos(vacantesNew);
    }
    // eslint-disable-next-line
  }, [vacantesoples, vacantes]);

  useEffect(() => {
    if (idConcurso === 2 && idConvocatoria && estado !== undefined) {
      dispatch(getVacantesOples(idConcurso, idConvocatoria, estado));
    }
    // eslint-disable-next-line
  }, [idConcurso, idConvocatoria, estado]);

  useEffect(() => {
    if (vacante === 999999) {
      if (
        idConcurso === 1 &&
        idConvocatoria &&
        vacante !== undefined &&
        estado === null
      ) {
        dispatch(getVacantes(idConcurso, idConvocatoria));
      }
    }
    // eslint-disable-next-line
  }, [idConcurso, idConvocatoria, vacante]);

  useEffect(() => {
    if (listaVacantes.length > 0) {
      if (idSistema === 1) {
        seleccionarCardINE(listaVacantes[0], 0);
      } else if (idSistema === 2) {
        seleccionarCard(listaVacantes[0], 0);
      }
    }
    // eslint-disable-next-line
  }, [listaVacantes]);

  //const amount = 654321.987;
  const options1 = { style: "currency", currency: "MXN" };
  const formatoMoneda = new Intl.NumberFormat("es-MX", options1);
  //console.log(formatoMoneda.format(amount));

  const seleccionarCard = (item, index) => {
    setCargoPuestoSeleccionado(index);
    //console.log(getWindowDimensions().width);
    if (getWindowDimensions().width < 1200) {
      showModalContenidoVacanteFunction();
    }
    /*  if (isMobile) { */
    /* } */
    dispatch(asignarVacante(item));
    dispatch(getObjetivos(item.idCargoPuesto));
    dispatch(getFunciones(item.idCargoPuesto));
    dispatch(getRequisitos(item.idCargoPuesto));
  };

  const seleccionarCardINE = (item, index) => {
    setCargoPuestoSeleccionado(index);

    if (getWindowDimensions().width < 1200) {
      showModalContenidoVacanteFunction();
    }
    /* if (isMobile) { */
    /* showModalContenidoVacanteFunction(); */
    /* } */
    dispatch(asignarVacante(item));
    dispatch(getObjetivoINE(item.idTipoCargoPuesto));
    dispatch(getFuncionesINE(item.idTipoCargoPuesto));
    dispatch(getRequisitosINE(item.idTipoCargoPuesto));

    // const existePostulacion = listPostula.find(
    //   (e) => e.denominacion === item.denominacion
    // );
    // if (existePostulacion !== undefined) {
    //   dispatch(btnBandera(1));
    // } else {
    //   dispatch(btnBandera(0));
    // }
  };

  const hasWindow = typeof window !== "undefined";

  const getWindowDimensions = () => {
    const width = hasWindow ? window.innerWidth : null;
    const height = hasWindow ? window.innerHeight : null;
    return {
      width,
      height,
    };
  };

  const showModalContenidoVacanteFunction = () => {
    setShowModalContenidoVacante(!showModalContenidoVacante);
  };

  return (
    <>
      <Form layout="vertical">
        <div
          className={
            listaVacantes.length > 0
              ? "mainConsultaVacantes"
              : "mainConsultaVacantesEmpty"
          }
        >
          <div id="scrollableDiv">
            {idSistema === 2 && (
              <div className="filtros">
                <Row>
                  <Col span={24}>
                    <Form.Item
                      label={<div className="formItemText">Estado:</div>}
                    >
                      <Select
                        showSearch
                        placeholder="Seleccione una opción"
                        allowClear
                        value={estado}
                        onChange={(value) => selectEstado(value)}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {estadosTodos !== undefined &&
                          estadosTodos.map((item, index) => (
                            <Option key={index} value={item.idEstado}>
                              {item.nombreEstado}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                {estado && estado !== 1000 ? (
                  <Row>
                    <Col span={24}>
                      <Form.Item
                        label={
                          <div className="formItemText">Cargo/Puesto:</div>
                        }
                      >
                        <Select
                          showSearch
                          allowClear
                          placeholder="Seleccione una opción"
                          value={vacante}
                          disabled={cargoPuestoActivo}
                          onChange={(value) => selectVacante(value)}
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {vacantesoples !== undefined &&
                            vacantesoples.map((item, index) => (
                              <Option key={index} value={item.idCargoPuesto}>
                                {item.denominacion}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col span={24}>
                      <Form.Item
                        label={
                          <div className="formItemText">Cargo/Puesto:</div>
                        }
                      >
                        {idSistema === 1 && (
                          <Select
                            showSearch
                            placeholder="Seleccione una opción"
                            allowClear
                            value={vacante}
                            onChange={(value) => selectVacanteINE(value)}
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {vacantesTodos.map((item, index) => (
                              <Option
                                key={index}
                                value={item.idTipoCargoPuesto}
                              >
                                {item.nombretipo}
                              </Option>
                            ))}
                          </Select>
                        )}
                        {idSistema === 2 && (
                          <Select
                            showSearch
                            placeholder="Seleccione una opción"
                            allowClear
                            value={vacante}
                            disabled={cargoPuestoActivo}
                            onChange={(value) => selectVacante(value)}
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {vacantesTodos.map((item, index) => (
                              <Option key={index} value={item.idCargoPuesto}>
                                {item.denominacion}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                )}
              </div>
            )}
            {idSistema === 1 && (
              <div className="filtros">
                {estado && estado !== 1000 ? (
                  <Row>
                    <Col span={24}>
                      <Form.Item
                        label={
                          <div className="formItemText">Cargo/Puesto:</div>
                        }
                      >
                        <Select
                          showSearch
                          allowClear
                          placeholder="Seleccione una opción"
                          value={vacante}
                          onChange={(value) => selectVacante(value)}
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {vacantesoples !== undefined &&
                            vacantesoples.map((item, index) => (
                              <Option key={index} value={item.idCargoPuesto}>
                                {item.denominacion}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col span={24}>
                      <Form.Item
                        label={
                          <div className="formItemText">Cargo/Puesto:</div>
                        }
                      >
                        {idSistema === 1 && (
                          <Select
                            showSearch
                            placeholder="Seleccione una opción"
                            allowClear
                            value={vacante}
                            onChange={(value) => selectVacanteINE(value)}
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {vacantesTodos.map((item, index) => (
                              <Option
                                key={index}
                                value={item.idTipoCargoPuesto}
                              >
                                {item.nombretipo}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                )}
              </div>
            )}
            <div>
              <List
                itemLayout="vertical"
                size="large"
                locale={emptyData}
                dataSource={listaVacantes}
                pagination={{
                  showSizeChanger: true, // La pantalla puede cambiar el número de cada página
                  pageSizeOptions: ["5", "10", "15", "20"], // Número de opciones por página
                  showTotal: (total) => `Total ${total} registros`, // mostrar total de registros
                  showSizeChange: (pageSize) => (this.pageSize = pageSize), // Actualiza la pantalla al cambiar el número de cada página
                }}
                renderItem={(item, index) => (
                  <List.Item>
                    {
                      // eslint-disable-next-line
                      <div
                        onClick={() =>
                          idSistema === 1
                            ? seleccionarCardINE(item, index)
                            : seleccionarCard(item, index)
                        }
                      >
                        <Card
                          className={`cardConsultaVacantes ${
                            cargoPuestoSeleccionado === index && "active"
                          } `}
                          hoverable={true}
                        >
                          <Row>
                            <Col
                              span={2}
                              className="cardcardConsultaVacantesNumeracion"
                            >
                              <div className="verticalCenter">{index + 1}</div>
                            </Col>
                            <Col
                              span={22}
                              className="cardcardConsultaVacantesTextContainer"
                            >
                              <div className="cardConsultaVacantesTitle">
                                Denominación:
                              </div>
                              <div>
                                {idSistema === 1 && <>{item.nombretipo} </>}
                                {idSistema === 2 && <>{item.denominacion} </>}
                              </div>
                              <div className="cardConsultaVacantesTitle">
                                Sueldo:
                              </div>
                              <div>
                                {formatoMoneda.format(item.sueldomensual)}{" "}
                                mensuales
                              </div>
                            </Col>
                          </Row>
                        </Card>
                      </div>
                    }
                  </List.Item>
                )}
              />
            </div>
          </div>
        </div>
      </Form>
      <div className="test">
        <ContenidoVacanteModalComponent
          showModalContenidoVacante={showModalContenidoVacante}
          showModalContenidoVacanteFunction={showModalContenidoVacanteFunction}
        />
      </div>
    </>
  );
};
